module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAbCAYAAACAyoQSAAAAq0lEQVRIS2NkaDjzn4HOgHHUUlqG+Gjw0jJ0GUaDd3AGLxMjA0OSoQhDja0kg8LEyyQ5kqw4NZPmYpjiKcdgKs0Ntoyx8SztLBXlYmFod5ZmSDQUZmBiZIRbRFNLb2RrM6iLcGD4iqaWinGzMLSBfGpAR5/CvGgmzc0wxVOWPnGKHK6w1FtrJ8kgP4EOqZekpIpFMVlZZtRSYkNgNHiJDSmy1I0GL1nBRqwmAHJuUwXxTMtOAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/images/turnleft.png
// module id = odJc
// module chunks = 1